import React from 'react';
import PageLayout from '../components/PageLayout';
import PageHero from '../components/PageHero';
import BookingForm from '../components/BookingForm';

export default function BookConsultation() {
  return (
    <PageLayout>
      <PageHero
        eyebrow="Free consult"
        title="Book Your Free Consultation"
        subtitle="Schedule a free consultation with us to discuss your website needs."
        className="pb-8 md:pb-10"
      />

      <section className="px-4 md:px-8 pb-20">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm p-6 md:p-10 rounded-2xl shadow-xl border border-white/20">
            <BookingForm />
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
